import styled from 'styled-components'

const Controls = styled('div')`
  position: absolute;
  top: 0;
  right: 0;

  display: flex;
  flex-flow: column nowrap;

  margin: 10px;
  width: 50px;
`

export default Controls
